<template>
  <div :class="this.deviceClass == 'pc' ? 'shortBox' : 'shortBoxH'">
    <pageModel3 />
  </div>
</template>

<script>
import pageModel3 from '@/views/short/components/pageModel3.vue'
export default {
  components: { pageModel3 },
  name: 'notFound',
  data() {
    return {}
  },
  created() {
    sessionStorage.removeItem('shortFshort')
  },
  computed: {
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
  },
  methods: {},
}
</script>
